import styled from "styled-components/macro";

export const StyledLandingHeader = styled.header`
  display: grid;
  row-gap: 0.5rem;
`;

export const StyledLandingHeading = styled.h1`
  font-size: 3.2rem;
`;

export const StyledLandingSubHeading = styled.p`
  font-size: 1.6rem;
`;
